import {
	AssetProperties,
	AssetPropertiesProps,
} from '../AssetProperties';
import { FeatureItem, ItemDetailsSelector } from '../../utils';
import { getAsset, getAssetWithExtendedData } from '../../../../redux/asset/actions';
import {
	selectAssetById,
	selectExtendedAssetById,
} from '../../../../redux/asset/selectors/asset';

import React from 'react';
import { Tab } from '../Tab';
import { useGlobalization } from '@Translations/useGlobalization';

interface AssetsTabProps extends Omit<AssetPropertiesProps, 'item'> {
	items: FeatureItem[];
	highlightAssets?: (assets: string[]) => void;
}

const getItemNameAsset = (item: FeatureItem): string => {
	return `${item.assetId || item.name || item.NAME || item.Name || item.id}`;
};

export const AssetsTab = ({
	items,
	highlightAssets,
	...other
}: AssetsTabProps): JSX.Element => {
	const { t } = useGlobalization();

	const { showInspections } = other;
	const getItemDetailsAction = showInspections
		? getAssetWithExtendedData
		: getAsset;
	const getItemDetailsSelector = showInspections
		? selectExtendedAssetById
		: selectAssetById;

	return (
		<Tab
			items={items}
			tabName={t('Assets', {
				context: 'Property pane tab heading',
			}) ?? 'Assets'}
			detailView={item => <AssetProperties item={item} {...other} />}
			getItemDetailsAction={getItemDetailsAction}
			getItemDetailsSelector={
				getItemDetailsSelector as ItemDetailsSelector
			}
			getItemName={getItemNameAsset}
			highlightAssets={highlightAssets}
		/>
	);
};
